'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import '../app/nprogress-custom.css' // Custom styles for NProgress

export default function NProgressBar() {
    const pathname = usePathname()

    useEffect(() => {
        NProgress.start()
        // finish after route change
        const timeout = setTimeout(() => NProgress.done(), 500)
        return () => clearTimeout(timeout)
    }, [pathname])

    return null
}
